"use client";

import { useLayoutEffect, useState } from "react";

export const useScreenWidth = (): number => {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    setWidth(window.screen.width);
  }, []);

  return width;
};
